module.exports = __webpack_public_path__ + "img/wxewm_16.7f382619.png";